import { useEffect, useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { PortalLayout } from "@/components/layout/PortalLayout";
import { GlassCard } from "@/components/GlassCard";
import api from "@/lib/api";

export default function RepoHealth() {
  const [h, setH] = useState(null);
  useEffect(() => { api.get("/admin/repo-health").then((r) => setH(r.data)); }, []);
  if (!h) return <PortalLayout title="Repo Health"><p className="text-sm text-muted-foreground">Loading…</p></PortalLayout>;
  return (
    <PortalLayout title="Repo Health">
      <div className="grid gap-5 sm:grid-cols-3">
        <GlassCard className="p-5"><div className="pdg-kicker">Build status</div><div className="mt-3 pdg-serif text-2xl text-[hsl(145_38%_66%)] capitalize">{h.build_status}</div></GlassCard>
        <GlassCard className="p-5"><div className="pdg-kicker">Collections</div><div className="mt-3 pdg-serif text-2xl text-foreground">{h.collections}</div></GlassCard>
        <GlassCard className="p-5"><div className="pdg-kicker">Last build</div><div className="mt-3 text-sm text-foreground pdg-mono">{new Date(h.last_build).toLocaleString()}</div></GlassCard>
      </div>
      <GlassCard className="p-6 mt-6">
        <h2 className="pdg-serif text-2xl text-foreground mb-4">Checks</h2>
        <div className="space-y-3">
          {(h.checks || []).map((c) => (
            <div key={c.name} className="flex items-center justify-between py-2 border-b border-border">
              <span className="text-sm text-foreground/85">{c.name}</span>
              <span className="flex items-center gap-2 text-xs text-[hsl(145_38%_66%)]"><CheckCircle2 size={15} /> {c.status}</span>
            </div>
          ))}
        </div>
        <div className="mt-6 flex gap-6 text-sm text-muted-foreground">
          {Object.entries(h.stack || {}).map(([k, v]) => <div key={k}><span className="pdg-kicker mr-2">{k}</span>{v}</div>)}
        </div>
      </GlassCard>
    </PortalLayout>
  );
}
